import { ref } from "vue";

export function useFeedback() {
  const editedFields = ref(new Set());
  const currentFieldId = ref(null);

  const markFieldAsEdited = (fieldId) => {
    editedFields.value.add(fieldId);
    currentFieldId.value = fieldId;
  };

  const clearFieldFeedback = (fieldId) => {
    editedFields.value.delete(fieldId);
    if (currentFieldId.value === fieldId) {
      currentFieldId.value = null;
    }
  };

  const isFieldEdited = (fieldId) => {
    return editedFields.value.has(fieldId);
  };

  const getCurrentFieldId = () => {
    return currentFieldId.value;
  };

  return {
    markFieldAsEdited,
    clearFieldFeedback,
    isFieldEdited,
    getCurrentFieldId,
  };
}
